export const countryOptions = [
  { key: 'Argentina', value: 'Argentina', label: 'Argentina' },
  { key: 'Alemania', value: 'Alemania', label: 'Alemania' },
  { key: 'Bélgica', value: 'Bélgica', label: 'Bélgica' },
  { key: 'Bolivia', value: 'Bolivia', label: 'Bolivia' },
  { key: 'Brasil', value: 'Brasil', label: 'Brasil' },
  { key: 'Canadá', value: 'Canadá', label: 'Canadá' },
  { key: 'Chile', value: 'Chile', label: 'Chile' },
  { key: 'China', value: 'China', label: 'China' },
  { key: 'Colombia', value: 'Colombia', label: 'Colombia' },
  { key: 'Corea del Sur', value: 'Corea del Sur', label: 'Corea del Sur' },
  { key: 'Costa Rica', value: 'Costa Rica', label: 'Costa Rica' },
  { key: 'Dinamarca', value: 'Dinamarca', label: 'Dinamarca' },
  { key: 'Ecuador', value: 'Ecuador', label: 'Ecuador' },
  { key: 'España', value: 'España', label: 'España' },
  { key: 'Estados Unidos', value: 'Estados Unidos', label: 'Estados Unidos' },
  { key: 'Francia', value: 'Francia', label: 'Francia' },
  { key: 'Guatemala', value: 'Guatemala', label: 'Guatemala' },
  { key: 'Honduras', value: 'Honduras', label: 'Honduras' },
  { key: 'India', value: 'India', label: 'India' },
  { key: 'Indonesia', value: 'Indonesia', label: 'Indonesia' },
  { key: 'Italia', value: 'Italia', label: 'Italia' },
  { key: 'Japón', value: 'Japón', label: 'Japón' },
  { key: 'Malasia', value: 'Malasia', label: 'Malasia' },
  { key: 'México', value: 'México', label: 'México' },
  { key: 'Nicaragua', value: 'Nicaragua', label: 'Nicaragua' },
  { key: 'Panamá', value: 'Panamá', label: 'Panamá' },
  { key: 'Paraguay', value: 'Paraguay', label: 'Paraguay' },
  { key: 'Perú', value: 'Perú', label: 'Perú' },
  { key: 'Reino Unido', value: 'Reino Unido', label: 'Reino Unido' },
  { key: 'República Dominicana', value: 'República Dominicana', label: 'República Dominicana' },
  { key: 'Suecia', value: 'Suecia', label: 'Suecia' },
  { key: 'Taiwán', value: 'Taiwán', label: 'Taiwán' },
  { key: 'Turquía', value: 'Turquía', label: 'Turquía' },
  { key: 'Uruguay', value: 'Uruguay', label: 'Uruguay' },
  { key: 'Venezuela', value: 'Venezuela', label: 'Venezuela' },
]
